/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecurityFileUploadResponse } from '../../models/security-file-upload-response';
import { StoreSecurityFile } from '../../models/store-security-file';

export interface StoreSecurityFile$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
      body?: StoreSecurityFile
}

export function storeSecurityFile(http: HttpClient, rootUrl: string, params: StoreSecurityFile$Params, context?: HttpContext): Observable<StrictHttpResponse<SecurityFileUploadResponse>> {
  const rb = new RequestBuilder(rootUrl, storeSecurityFile.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SecurityFileUploadResponse>;
    })
  );
}

storeSecurityFile.PATH = '/custom/station/{uid}/SecurityFile';
